import React, { useMemo } from "react";
import "../css/TrainingServicesCard.css"; // Create this CSS file or copy from Boarding

const TrainingServiceCard = ({ data = [] }) => {
  const trainingData = useMemo(
    () => data.find((item) => item.service === "Training"),
    [data]
  );

  const totalSessions = trainingData?.overall_training_sessions || 0;
  const totalRevenue = trainingData?.overall_training_revenue || 0;
  const ongoing = trainingData?.ongoing_sessions || 0;
  const pending = trainingData?.pending_sessions || 0;
  const completed = trainingData?.completed_sessions || 0;
  const topTrainer = trainingData?.top_trainer || "—";

  return (
    <div className="training-service-card">
      <div className="training-service-title">Training</div>
      <div className="training-service-content">
        <div className="training-service-row">
          <span className="training-service-label">Overall Training Sessions</span>
          <span className="training-service-colon">:</span>
          <span className="training-service-value">{totalSessions}</span>
        </div>
        <div className="training-service-row">
          <span className="training-service-label">Total Revenue</span>
          <span className="training-service-colon">:</span>
          <span className="training-service-value">₹{totalRevenue.toLocaleString()}</span>
        </div>
        <div className="training-service-row">
          <span className="training-service-label">Ongoing Sessions</span>
          <span className="training-service-colon">:</span>
          <span className="training-service-value">{ongoing}</span>
        </div>
        <div className="training-service-row">
          <span className="training-service-label">Pending Sessions</span>
          <span className="training-service-colon">:</span>
          <span className="training-service-value">{pending}</span>
        </div>
        <div className="training-service-row">
          <span className="training-service-label">Completed Sessions</span>
          <span className="training-service-colon">:</span>
          <span className="training-service-value">{completed}</span>
        </div>
        <div className="training-service-row">
          <span className="training-service-label">Top Trainer</span>
          <span className="training-service-colon">:</span>
          <span className="training-service-value">{topTrainer}</span>
        </div>
      </div>
    </div>
  );
};

export default TrainingServiceCard;
